var _rect, _g, _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFailedEllipse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 131,
    viewBox: "0 0 179 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 77.2422,
    y: 18.2842,
    width: 23.0737,
    height: 72.1053,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_10560_17989)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.5,
    cy: 105.532,
    rx: 68.5,
    ry: 5.04737,
    fill: "#EA4335"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89.5001,
    cy: 56.5001,
    r: 55.5211,
    fill: "#E74C3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.5 32.7053V57.9422",
    stroke: "white",
    strokeWidth: 7.57105,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5 79.3934C92.2876 79.3934 94.5474 77.1337 94.5474 74.3461C94.5474 71.5585 92.2876 69.2987 89.5 69.2987C86.7124 69.2987 84.4526 71.5585 84.4526 74.3461C84.4526 77.1337 86.7124 79.3934 89.5 79.3934Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_10560_17989",
    x: 0.810526,
    y: 80.2948,
    width: 177.379,
    height: 50.4738,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.0947,
    result: "effect1_foregroundBlur_10560_17989"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedEllipse);
export default __webpack_public_path__ + "static/media/failed_ellipse.f7a4908ddf872cfaa43c5485e2c5a3a9.svg";
export { ForwardRef as ReactComponent };